import { DrugItem, FetchAttr } from '../types';
import { getData } from '../utils';

const getTopDrugs = async (attr?: FetchAttr): Promise<DrugItem[]> => {
  const response = await getData('drug/top10', attr);
  return response;
};

export default getTopDrugs;
